import { render } from "./NotifUnsubscribe.vue?vue&type=template&id=4c3fa7b5"
import script from "./NotifUnsubscribe.vue?vue&type=script&lang=ts"
export * from "./NotifUnsubscribe.vue?vue&type=script&lang=ts"
script.render = render

export default script